
let _ = require('../_.js');
let $ = jQuery;

_.show_the_entire_auction_was_completed_modal = function (modal_data) {

    _.Notification_Auction_Completed_Loser.hide_this_variations_details();
    _.Notification_Auction_Completed_Winner.hide_this_variations_details();

    let $modal = $("#ac-modal-auction-completed-public-modal");

    $modal.find('.btn-show-auction-summary').hide();

    $("#completed-public-modal-am-name").text(modal_data.am_name);
    $("#completed-public-modal-am-phone").empty().append($("<a></a>").attr('a', 'tel:' + modal_data.am_phone).text(_.formatPhoneNumber(modal_data.am_phone)));
    $("#completed-public-modal-am-email").empty().append($("<a></a>").attr('a', 'mailto:' + modal_data.am_email).text(modal_data.am_email));

    $modal.modal_show();

}